export default __webpack_public_path__ + "static/media/FoodChainForest_04.644263dc.png";